<template>
    <div class="modal-card card">
        <div class="card-header">
            <h4 class="card-header-title">Edit Parameter Values</h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="card-body">
            <div class="table-responsive">
                <table class="table table-sm mt-2 lakeview-parameters-table">
                    <colgroup>
                        <col />
                        <col />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(param, index) in parameters" :key="index">
                            <td class="px-1 py-2">
                                <input style="padding: 2px 7px;" class="form-control" type="text" :disabled="true"
                                    v-model="param.name" />
                            </td>
                            <td class="px-1 py-2">
                                <InputField v-if="param.type?.includes?.('[]')" type="multiselect" colField=""
                                    v-model="param.values" :showLabel="false" />
                                <input v-else style="padding: 2px 7px;" class="form-control" type="text"
                                    v-model="param.value" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card-footer text-end">
            <button class="btn btn-success" :disabled="saving" @click="saveParameters">
                <div v-if="saving" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <div v-else>
                    Save
                </div>
            </button>
        </div>
    </div>
</template>

<script>
import InputField from "../InputField.vue";
import { mapActions } from "vuex";

export function formatLakeviewParameterValueColumn(data, row) {
    if (typeof row?.type === "string" && row.type.includes("[]")) {
        const vals = row.values;
        return Array.isArray(vals) ? vals.join(", ") : vals != null ? String(vals) : "";
    }
    return data == null ? "" : data;
}

export default {
    components: { InputField },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    data() {
        return {
            parameters: [],
            saving: false,
            selectedSandbox: this.$route.params.sandboxId,
        };
    },
    computed: {
        isProdV2Sandbox() {
            const sandboxes = this.$store.state.sandbox.prodV2Sandboxes;
            return sandboxes.some((sandbox) => sandbox.name === this.selectedSandbox);
        },
    },
    beforeMount() {
        this.parameters = JSON.parse(JSON.stringify(this.$store.state.amdp.lakeviewParameters));
    },
    methods: {
        ...mapActions({
            fetchParameters: "amdp/fetchLakeviewParameters",
            updateParameters: "amdp/updateLakeviewParameters",
            updateProdV2PromotionDirect: "sandbox/updateProdV2PromotionDirect",
        }),
        async saveParameters() {
            this.saving = true;
            let toastOptions;
            const sandboxName = this.$route.params.sandboxId;
            const jobName = this.$route.params.jobId;
            const fetchOpts = { sandboxName, jobName };
            const payload = { parameters: this.parameters };

            try {
                if (!this.isProdV2Sandbox) {
                    await this.updateParameters({
                        sandboxName,
                        jobName,
                        payload,
                    });
                } else {
                    await this.updateProdV2PromotionDirect({
                        sandboxId: sandboxName,
                        jobName,
                        payload,
                    });
                }
                toastOptions = {
                    message: "Default values updated successfully.",
                    type: "success",
                };
                this.fetchParameters(fetchOpts);
                this.$store.dispatch("hideModal");
            } catch (error) {
                const err =
                    error.response?.data?.error != null
                        ? error.response.data.error
                        : error.message;
                toastOptions = {
                    message: err || "Something went wrong when updating parameters. Please contact support.",
                    type: "error",
                };
            } finally {
                this.saving = false;
                this.$store.dispatch("addToast", toastOptions);
            }
        },
    },
};
</script>

<style scoped>
.lakeview-parameters-table {
    table-layout: fixed;
    width: 100%;
}

.lakeview-parameters-table col:first-child {
    width: 36%;
}

.lakeview-parameters-table col:last-child {
    width: 64%;
}

.lakeview-parameters-table th:first-child,
.lakeview-parameters-table td:first-child {
    min-width: 11rem;
}

.lakeview-parameters-table th,
.lakeview-parameters-table td {
    vertical-align: top;
    white-space: normal;
    overflow-wrap: anywhere;
}

.lakeview-parameters-table .form-control {
    min-width: 0;
    width: 100%;
}

.lakeview-parameters-table td:last-child :deep(.form-group) {
    min-width: 0;
    max-width: 100%;
}

.lakeview-parameters-table td:last-child :deep(.multiselect) {
    min-width: 0;
    max-width: 100%;
    width: 100%;
    justify-content: flex-start;
}

.lakeview-parameters-table td:last-child :deep(.multiselect-tags) {
    flex: 1 1 0%;
    min-width: 0 !important;
    max-width: 100%;
}

.lakeview-parameters-table td:last-child :deep(.multiselect-tag) {
    min-width: 0;
    max-width: 100%;
    white-space: normal !important;
    overflow-wrap: anywhere;
    word-break: break-word;
}
</style>
